import { render, staticRenderFns } from "./userreg.vue?vue&type=template&id=51f2ed26"
import script from "./userreg.vue?vue&type=script&lang=js"
export * from "./userreg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports